
export const imageUri = state => state.imageLayer.uri
export const getSelectedFile = state => state.imageLayer.file